export default __webpack_public_path__ + "bbdb9249d6eca76ecd788cab4414c938.png";